export enum Rol {
    Archwiliwr = 'Archwiliwr',
    Defnyddiwr = 'Defnyddiwr',
    Yswiriant = 'Yswiriant',
    Mecanig = 'Mecanig',
    Gweinyddwr = 'Gweinyddwr',
    UwchWeinyddwr = 'UwchWeinyddwr'
}

export class Polisi {
    static PolisiUwchWeinyddwr = [Rol.UwchWeinyddwr];
    static PolisiGweinyddwr = [Rol.UwchWeinyddwr, Rol.Gweinyddwr];
    static PolisiYswiriant = [Rol.UwchWeinyddwr, Rol.Gweinyddwr, Rol.Yswiriant];
    static PolisiMecanig = [Rol.UwchWeinyddwr, Rol.Gweinyddwr, Rol.Mecanig];
    static PolisiDefnyddiwr = [Rol.UwchWeinyddwr, Rol.Gweinyddwr, Rol.Mecanig, Rol.Yswiriant, Rol.Defnyddiwr];
    static PolisiArchwiliwr = [Rol.UwchWeinyddwr, Rol.Gweinyddwr, Rol.Mecanig, Rol.Yswiriant, Rol.Defnyddiwr, Rol.Archwiliwr];
}

export enum TenantMath
{
    Diofyn = "Diofyn",
    Gwynedd= "Gwynedd",
    PriffyrddGwynedd= "Priffyrdd",
    Fflint = "Flintshire",
    FflintSmallPlant = "Flintshire Small Plant",
    Conwy = "Conwy"
}